<kf-dialog>
  <div class="dialog-root" if="{ props.dialog.show }" onclick="{ props.onClose }">
    <div class="dialog-container">
      <div onclick="{ onContainerClick }" class="dialog-content">
        <span class="dialog-close" onclick="{ props.onClose }">&times;</span>
        <div>
          <div class="dialog-message">
            <i if="{ props.dialog.status == 'success' }" class="icon icon-success far fa-check-circle"></i>
            <i if="{ props.dialog.status == 'failed' }" class="icon icon-failed fas fa-times"></i>
            <i if="{ props.dialog.status == 'info' }" class="icon icon-info fas fa-info"></i>
            { props.dialog.message }
          </div>
          <div class="flex">
            <button if="{ props.dialog.reload }" class="reload-button" onclick="{ reload }">再読み込み</button>
            <button class="close-button" onclick="{ props.onClose }">閉じる</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <script>
    export default {
      focusClose() {
        setTimeout(() => {
          this.$('.close-button')?.focus();
        }, 1);
      },
      onContainerClick(e) {
        e.stopPropagation();
      },
      onUpdated(props) {
        if (props.dialog.show) {
          this.focusClose();
        }
      },
      reload() {
        location.reload();
      },
    };
  </script>
  <style type="postcss">
    .dialog-message {
      font-size: 1.2rem;
      white-space: pre-wrap;
      word-break: break-all;
      padding-bottom: 10px;
    }

    .dialog-root {
      position: fixed;
      z-index: 10000;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      overflow: auto;
      background-color: rgb(0, 0, 0);
      background-color: rgba(0, 0, 0, 0.4);
    }

    .dialog-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      height: 100%;
      justify-content: center;
    }

    .dialog-content {
      margin-top: 50px;
      display: inline-block;
      position: relative;
      z-index: 10001;
      width: 80%;
      max-width: 100%;
      overflow-y: auto;
      max-height: 85%;
      padding: 20px;
      background-color: #ffffff;
      border-radius: .4rem;
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
      margin-top: 0;
      width: 370px;
    }

    .dialog-close {
      color: rgb(206, 206, 206);
      position: fixed;
      right: .3rem;
      top: .0;
      font-size: 34px;
      font-weight: bold;
    }

    .dialog-close:hover,
    .dialog-close:focus {
      color: black;
      text-decoration: none;
      cursor: pointer;
    }

    .icon {
      font-size: 1.4rem;
      margin-right: 8px;
    }

    .icon-success {
      color: rgb(17, 236, 17);
    }

    .icon-failed {
      color: rgb(248, 37, 37);
    }

    .icon-info {
      color: rgb(0, 162, 255);
    }

    .close-button {
      background-color: white;
      border: 1px solid #ccc;
      border-radius: 4px;
      user-select: none;
      cursor: pointer;
      vertical-align: middle;
      text-align: center;
      padding: 5px 10px;
      margin-left: auto;
    }
    .close-button:focus{
      outline: 2px solid black;
      outline-offset: 1px;
    }

    .reload-button {
      background-color: #ddd;
      border-radius: 4px;
      user-select: none;
      cursor: pointer;
      vertical-align: middle;
      text-align: center;
      padding: 5px 10px;
      border: none;
    }
  </style>
</kf-dialog>